import { z } from 'zod';

export const segmentDimensionSchema = z.enum(['class', 'location']);
export type SegmentDimension = z.infer<typeof segmentDimensionSchema>;

export const segmentIncomeStatementQuerySchema = z.object({
  from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  dimension: segmentDimensionSchema,
});
export type SegmentIncomeStatementQuery = z.infer<typeof segmentIncomeStatementQuerySchema>;

export interface SegmentRow {
  code: string;
  name: string;
  accountType: string;
  /** Natural-sign net per segment id (income positive; cost positive). */
  amounts: Record<string, string>;
}

export interface SegmentSummary {
  revenue: Record<string, string>;
  cogs: Record<string, string>;
  grossProfit: Record<string, string>;
  expense: Record<string, string>;
  otherIncome: Record<string, string>;
  otherExpense: Record<string, string>;
  netIncome: Record<string, string>;
}

export interface SegmentIncomeStatementResponse {
  from: string;
  to: string;
  dimension: SegmentDimension;
  /** Columns; includes the 'unassigned' segment when present. */
  segments: { id: string; name: string }[];
  rows: SegmentRow[];
  summary: SegmentSummary;
}
